<div #panel [class]="cx('panel')">
  <div [class]="cx('list')" (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
    <ng-content />
  </div>
</div>
